import * as React from 'react';

import { TestProviders } from './TestContainer';

export const LuminovoStorybookThemeDecorator = (Story: React.ComponentType): JSX.Element => {
    return (
        <TestProviders>
            <Story />
        </TestProviders>
    );
};
